import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import avatar from './avatar.png'
import { makeRequestFormRequest } from '../../../utils';
import mainContext from '../../../contexts/mainContext';
import { __constants, __snackBarSeverity } from '../../../constants';
import { getEditSKProfile, saveUserProfile } from '../../../Controllers/EditProfile';
import './seeker.css'
import Tags from '../../../common_components/Tags';
import AddChild from './AddChild';
import { getCitiesListing, getAreasListing } from "../../../Controllers/ScopeManagement"
const APP_URL = process.env.REACT_APP_SERVER_URL

export function Seeker({ setOpen, userId, cb }) {
  const { setSnackBar, setPageload } = React.useContext(mainContext)
  const [cities, setCities] = React.useState([])
  const [areas, setAreas] = React.useState([])
  const [filteredAreas, setFilteredAreas] = React.useState([])

  /* Maintain state */
  const [state, setState] = React.useState({
    userInfo: {},
    cleaningEquipments: false,
    cleaningProducts: false,
    needs: [],
    langugages: [],
    lookingFor: [],
    pic: null,
    rawImage: null,
  })

  const formRef = React.useRef()

  React.useEffect(() => {
    async function getSeekerProfile() {
      const res = await getEditSKProfile(userId)
      if (res.status === 200) {
        setState({ ...state, ...res.data, rawImage: __constants.images + res.data.userInfo.profilePicture })
      } else {
        return callSnackBar(res.message, "error")
      }
      setPageload(false)
    }

    async function getCity() {
      const res = await getCitiesListing()
      if (res.data.status === 200) {
        setCities(res.data.data)
      }
    }

    const getArea = async () => {
      const res = await getAreasListing()
      if (res.data.status === 200) {
        setAreas(res.data.data)
      }
    }

    getCity()
    getArea()

    setPageload(true)
    /* Fetch Data */
    getSeekerProfile()
  }, [])

  React.useEffect(() => {
    if (areas.length > 0 && state.userInfo?.city) {
      const cityAreas = areas.filter((area) => area.cityId && area.cityId.city === state.userInfo.city)
      setFilteredAreas(cityAreas)
    }
  }, [areas, state.userInfo?.city])

  /* Call snackbar */
  const callSnackBar = (msg, type) => {
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type],
    })
  }

  const updateProfile = async (e) => {
    e.preventDefault()
    const request = makeRequestFormRequest(formRef)
    request.append("pic", state.pic)
    const needsId = [],
      formatChild = [],
      lookingFor = []
    state.needs.forEach((need) => need.isMarked && needsId.push(need._id))

    if (needsId.length === 0) {
      return callSnackBar("Please add atleast one need.", "error")
    }

    state.lookingFor.forEach((look) => look.isMarked && lookingFor.push(look.orgName))

    if (lookingFor.length === 0) {
      return callSnackBar("Please select looking for.", "error")
    }

    state.userInfo.childrens.length > 0 &&
      state.userInfo.childrens[0].forEach((child) => {
        if (!child.name) return callSnackBar("Please add child name", "error")
        else if (!child.dateOfBirth) return callSnackBar("Please add child date of birth", "error")
        formatChild.push({ name: child.name, dateOfBirth: child.dateOfBirth, gender: child.gender })
      })

    request.append("childrens", JSON.stringify(formatChild))
    request.append("needsIds", JSON.stringify(needsId))
    request.append("lookingFor", JSON.stringify(lookingFor))
    request.append("cleaningProducts", state.cleaningProducts)
    request.append("cleaningEquipments", state.cleaningEquipments)

    setPageload(true)
    const res = await saveUserProfile("Seeker", userId, request)
    setPageload(false)
    /* Handle Api response */
    if (res.data.status === 200) {
      cb(res.data.data)
      setOpen(false)
      return callSnackBar(res.data.message, "success")
    } else {
      return callSnackBar(res.data.errors[0].message, "error")
    }
  }

  /* Handle add/remove needs */
  const handleMyNeeds = (index) => {
    const temp = state.needs
    temp[index].isMarked = !temp[index].isMarked
    setState({ ...state, needs: temp })
  }

  /* Handle add/remove looking For */
  const handleLookingFor = (index) => {
    const temp = state.lookingFor
    temp[index].isMarked = !temp[index].isMarked
    setState({ ...state, lookingFor: temp })
  }

  /* Handle Add  Children logic */
  const handleChildrens = (noOfChild) => {
    const temp = state.userInfo
    let tempChild = temp.childrens.length > 0 ? [...temp?.childrens[0]] : []
    if (tempChild.length < noOfChild) {
      const array = Array(noOfChild - tempChild.length).fill({
        dateOfBirth: "",
        gender: "Male",
        name: "",
        _id: 0,
      })
      tempChild = tempChild.concat(array)
      if (temp.howManyKids.length > 0) temp.howManyKids[0] = noOfChild
      else temp.howManyKids = [noOfChild]
      if (temp.childrens.length > 0) temp.childrens[0] = tempChild
      else temp.childrens = [tempChild]
      setState({ ...state, userInfo: temp })
    }
  }

  /* Handle Remove child logic */
  const handleRemoveChild = (index) => {
    const temp = state.userInfo
    temp.childrens[0].splice(index, 1)
    temp.howManyKids[0] = temp.howManyKids[0] - 1
    setState({ ...state, userInfo: temp })
  }

  const handleChangeChildState = (type, data, index) => {
    const temp = state.userInfo
    if (type === "name") temp.childrens[0][index].name = data
    else if (type === "dob") temp.childrens[0][index].dateOfBirth = data
    setState({ ...state, userInfo: temp })
  }

  const handleCityChange = (e) => {
    const selectedCity = e.target.value

    // Filter areas based on selected city
    const cityAreas = areas.filter((area) => area.cityId && area.cityId.city === selectedCity)
    setFilteredAreas(cityAreas)

    // Update state with the new city
    setState({
      ...state,
      userInfo: {
        ...state.userInfo,
        city: selectedCity,
        area: "", // Reset area when city changes
      },
    })
  }

  return (
    <Container>
      <Header>
        <h4>
          {state.userInfo?.firstName} {state.userInfo?.lastName} Edit profile
        </h4>
        <CloseIcon
          className="pointer"
          onClick={() => {
            setOpen(false)
          }}
        />
      </Header>

      <form ref={formRef} onSubmit={updateProfile}>
        <div className="image_handler">
          <input
            type="file"
            id="picture"
            style={{ display: "none" }}
            onChange={(e) => {
              setState({ ...state, pic: e.target.files[0] })
            }}
          />
          <div className="img-box">
            <label htmlFor="picture">
              {state.pic ? (
                <img className="img-frame" src={URL.createObjectURL(state.pic) || "/placeholder.svg"} alt="Profile" />
              ) : (
                state.rawImage && (
                  <img
                    className="img-frame"
                    onError={(e) => {
                      setState({ ...state, rawImage: avatar })
                    }}
                    src={state.rawImage || "/placeholder.svg"}
                    alt="Profile"
                  />
                )
              )}
            </label>
          </div>
        </div>
        {state?.userInfo?.status && (
          <div className="form-box">
            <label htmlFor="status">Status</label>
            <select defaultValue={state?.userInfo?.status} name="status" id="status">
              <option value="Sleeping">Sleeping</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        )}
        <div className="form-box">
          <label htmlFor="firstName">First name(*)</label>
          <input
            required
            maxLength={30}
            name="firstName"
            id="firstName"
            type="text"
            className="input-box"
            defaultValue={state.userInfo?.firstName}
          />
        </div>
        <div className="form-box">
          <label htmlFor="lastName">Last name(*)</label>
          <input
            maxLength={30}
            name="lastName"
            id="lastName"
            type="text"
            className="input-box"
            defaultValue={state.userInfo?.lastName}
          />
        </div>
        <div className="form-box">
          <label className="c-text" htmlFor="email">
            Email(*)
          </label>
          <input
            disabled
            id="email"
            name="email"
            type="text"
            className="input-box"
            defaultValue={state.userInfo?.email}
          />
        </div>
        <div className="form-box">
          <label className="c-text" htmlFor="mobileNo">
            Mobile No(*)
          </label>
          <input
            disabled
            id="mobileNo"
            name="mobileNo"
            type="text"
            className="input-box"
            defaultValue={state.userInfo?.mobileNo}
          />
        </div>
        <div className="form-box">
          <label htmlFor="city">City</label>
          <select name="city" id="city" onChange={handleCityChange}>
            <option value="">Select City</option>
            {cities.map((data) => (
              <option key={data._id} value={data.city} selected={data.city === state?.userInfo?.city}>
                {data.city}
              </option>
            ))}
          </select>
        </div>

        <div className="form-box">
          <label htmlFor="area">Area</label>
          <select
            name="area"
            id="area"
            onChange={(e) => setState({ ...state, userInfo: { ...state.userInfo, area: e.target.value } })}
          >
            <option value="">Select Area</option>
            {filteredAreas.map((data) => (
              <option key={data._id} value={data.area} selected={data.area === state?.userInfo?.area}>
                {data.area}
              </option>
            ))}
          </select>
        </div>
        <div className="form-box ">
          <label htmlFor="address">Location of the task(*)</label>
          <textarea
            placeholder="Street, number, area"
            required
            maxLength={150}
            name="address"
            id="address"
            type="text"
            className="input-box"
            style={{ height: "initial" }}
            rows={4}
            defaultValue={state.userInfo?.address}
          />
        </div>
        <div className="form-box seeker-profile">
          <p className="labels">Looking For(*)</p>
          {state?.lookingFor?.map((obj, index) => (
            <Tags key={index} title={obj.name} isActive={obj?.isMarked} onClick={() => handleLookingFor(index)} />
          ))}
        </div>
        <div className="form-box">
          <label htmlFor="aboutMe">About(*)</label>
          <textarea
            required
            maxLength={400}
            name="aboutMe"
            id="aboutMe"
            type="text"
            className="input-box"
            style={{ height: "initial" }}
            rows={7}
            defaultValue={state.userInfo?.aboutMe}
          />
        </div>

        <section className="seeker-profile">
          <div className="sec-1">
            <p className="labels">Children</p>
            {[1, 2, 3, 4, 5].map((val) => (
              <Tags
                key={val}
                onClick={() => handleChildrens(val)}
                title={val}
                isActive={state.userInfo?.howManyKids?.length > 0 ? state.userInfo?.howManyKids[0] === val : false}
              />
            ))}
          </div>
          <div className="form-box">
            <label htmlFor="childrensDiscription">About children(*)</label>
            <textarea
              required
              maxLength={400}
              name="childrensDiscription"
              id="childrensDiscription"
              type="text"
              className="input-box"
              style={{ height: "initial" }}
              rows={7}
              defaultValue={state.userInfo?.childrensDiscription}
            />
          </div>
          <div className="sec-2">
            {state.userInfo?.childrens?.length > 0 &&
              state.userInfo?.childrens[0].map((child, index) => (
                <AddChild
                  key={index}
                  onRemove={() => handleRemoveChild(index)}
                  index={index}
                  name={child.name}
                  dateOfBirth={child.dateOfBirth}
                  handleChangeChildState={handleChangeChildState}
                />
              ))}
          </div>
          <div className="sec-3">
            <p className="labels">Housekeeping needs(*)</p>
            {state.needs.map((need, index) => (
              <Tags key={index} title={need.name} isActive={need.isMarked} onClick={() => handleMyNeeds(index)} />
            ))}
          </div>
          <div className="sec-4" style={{ marginTop: "10px" }}>
            <p className="labels">Cleaning products(*)</p>
            <Tags
              title={"Yes"}
              isActive={state.cleaningProducts}
              onClick={() => setState({ ...state, cleaningProducts: true })}
            />
            <Tags
              title={"No"}
              isActive={!state.cleaningProducts}
              onClick={() => setState({ ...state, cleaningProducts: false })}
            />
          </div>
          <div className="sec-5" style={{ marginTop: "10px" }}>
            <p className="labels">Cleaning equipment(*)</p>
            <Tags
              title={"Yes"}
              isActive={state.cleaningEquipments}
              onClick={() => setState({ ...state, cleaningEquipments: true })}
            />
            <Tags
              title={"No"}
              isActive={!state.cleaningEquipments}
              onClick={() => setState({ ...state, cleaningEquipments: false })}
            />
          </div>
        </section>

        <Button variant="outlined" type="submit">
          Update
        </Button>
      </form>
    </Container>
  )
}

const Container = styled("div")`
    height: 100vh;
    width: 30vw;
    padding: 1rem;
    .title{
        color: var(--nona-theme-color);
        font-size: 90%;
    }
    .divider-gap{
        margin: 0.5rem 0;
    }
    .button{
      border-radius: 10px;
      width: 100%;
      text-transform: unset;
      display: flex;
      font-family: 'semi-bold'
    }
    .chip{
        width: fit-content;
        background-color: var(--nona-light-blue);
    }
    .image_handler{
        padding:20px 0;
        margin-bottom:20px;
        border-radius : 300px 50px;
    }
    .img-box{
        margin: 0px auto;
    }
    .img-box img{
        display:block;
        margin: 0px auto;
        width:120px;
        height:120px;  
        border-radius:100%;
        // clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
    }
    form{
        display: flex;
        flex-direction: column;
        padding: 1rem;
        overflow: auto;
    }
    .form-box{
        margin-bottom:15px;
    }
    .form-box label{
        display:block;
        font-size : 14px;
        color : var(--theme-color);
        margin-bottom:0px;
    }
    .form-box .input-box{
        height:25px;
        width:100%;
        border:none;
        padding:2px 0px;
        outline : none;
        border-bottom:2px solid var(--card-border);
        display:block;
        font-size : 16px;
    }
    .form-box .input-box:focus{
        border-bottom:2px solid var(--theme-color);
    }
`

const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`
